 
  import { Options, Vue } from 'vue-class-component';   
  import Common from '@/services/common.js';    
  import 'bootstrap';
  import Basic from '@/components/Basic.vue';    
 

 
  import Axios from "axios";
  @Options({
    components: {  
      Basic, 
    }, 
  })

  export default class PlatformAgreement extends Vue { 
    pdf =''; 
    privacy ={}; 
    privacy_data =''; 
    STORAGE_KEY = "caprock-local";   
    data () {      
      Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';  
      this.get_privacys();  
      return { 
        privacy:this.privacy ,
        privacy_data:this.privacy_data, 
      }
    }   
  
    get_privacys(){ 
      Common.get_platform_agreement()
      .then(response => { 
        if(typeof response.data!== 'undefined' && response.data.success==200){  
          this.privacy_data =response.data.platform_agreement;
          // $('#htmld').html(response.data.privacy);
        }
      }).catch(e => {
          console.log(e)
      });
    } 

    created() {      
      document.title = 'Platform Agreement || Caprock Merchant Platform';  
    }
     
  } 
